<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室预约</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" @focus="dialogOpen1" style="width:320px;"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_no" filterable clearable
            :placeholder="`请选择${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">预约{{ $store.state.themeTitle }}室</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="160" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="预约人名称" width="120">
        </custom-table-column>
        <custom-table-column prop="order_user_name" label="工号" width="120">
        </custom-table-column>
        <custom-table-column prop="order_user_dep" label="预约人院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="project_name" :label="`${$store.state.themeTitle}项目`" width="160">
        </custom-table-column>
        <custom-table-column prop="order_date" label="预约日期" width="160">
        </custom-table-column>
        <custom-table-column prop="phone" label="联系方式" width="135">
        </custom-table-column>
        <custom-table-column prop="section" label="预约节次" min-width="235">
        </custom-table-column>
        <custom-table-column prop="reason" label="预约事由" min-width="220">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))"
              v-if="scope.row.status == 'apply'" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="770px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="132px" class="demo-ruleForm">
        <el-form-item label="预约人院系专业" prop="order_user_dep">
          <el-input v-model="selectName" placeholder="请选择预约人院系或专业" style="width:564px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;" :placeholder="`请选择`"
            @change="handleRoomChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="课程名称" prop="course_name">
          <el-input v-model="ruleForm.course_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="instrument_name">
          <el-input v-model="ruleForm.instrument_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="开始时间" prop="order_start">
          <el-date-picker type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss"  v-model="ruleForm.order_start" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="order_end">
          <el-date-picker type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.order_end" style="width:216px;"></el-date-picker>
        </el-form-item> -->
        <el-form-item :label="`${$store.state.themeTitle}项目`" prop="project_id">
          <el-select v-model="ruleForm.project_id" clearable filterable :placeholder="`请先选择院系专业`" style="width: 216px;"
            @change="handleProChange">
            <el-option v-for="item in projects" :key="item.id" :label="item.experiment_name" :value="item.id">
              <p>{{ item.experiment_name }}({{ item.experiment_code }})</p>
              <p v-if="item.instructor_name" class="el-option-tips">指导老师：{{ item.instructor_name }}</p>
              <p v-if="item.term" class="el-option-tips">学年学期：{{ item.term }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约日期" prop="order_date">
          <el-date-picker type="date" placeholder="请选择" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
            v-model="ruleForm.order_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="预约节次" prop="section">
          <el-cascader v-model="ruleForm.section" ref="cascader"
            :placeholder="ruleInfo.zdyysc ? `最多只能选择${ruleInfo.zdyysc}个节次` : `请选择`" :show-all-levels="false" :props="props"
            @change="handleCasCaderChage" style="width:564px;" clearable :options="sections"></el-cascader>
        </el-form-item>
        <el-form-item label="预约事由" prop="reason">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.reason"
            style="width:564px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinValidate, mixinFormatter],
  data() {
    return {
      classRooms: [],
      formInline: {
        training_no: '',
        status: '',
        structure_1: '',
        major: '',
      },
      props: {
        value: 'label',
        emitPath: false,
        multiple: true
      },
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        order_user_dep: '',
        major: '',
        phone: '',
        order_date: '',
        reason: '',
        project_id: '',
        project_name: '',
        section: [],
        training_room_id: '',
      },
      rules: {
        order_user_dep: [{ required: true, message: '请选择院系或专业' }],
        // order_user_dep: [{ required: true, message: '请选择预约人所在院系', trigger: '' }],
        reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        training_room_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        section: [{ required: true, message: `请选择`, trigger: 'change' }],

        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkphone, trigger: 'blur' },
        ],
        order_date: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      type: 'add',
      userInfo: {},
      projects: [],
      ruleInfo: {},
      sections: []
    };
  },
  created() {
    // this.userInfo = this.$store.state.userInfo;
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          return time.getTime() < Date.now() + 3600 * 1000 * 24 * (this.ruleInfo.tqyysj ? this.ruleInfo.tqyysj : 0);
        },
      };
    }
  },
  mounted() {
    // this.getList();
    this.title = `预约${this.$store.state.themeTitle}室`;
    this.$store.dispatch('getTarinMent', { type: 'all' });
    this.$store.dispatch('getSection');
    // this.getProjects()
  },
  // watch: {
  //   '$store.state.userInfo.defaultStructure': {
  //     handler: function (val) {
  //       this.userInfo = this.$store.state.userInfo;
  //       if (val) {
  //         this.selectName = val.structure_text2;
  //       }
  //     },
  //     deep: false,
  //   },
  // },
  methods: {
    handleRoomChange(val) {
      // this.ruleForm.project_id = ''
      // this.ruleForm.project_name = ''
      this.ruleForm.section = []
      this.ruleForm.order_date = ''
      this.getRules(val)
    },
    setSectionsIsDisabled() {
      let sections = this.$until.easyDeepCopy(this.$store.state.sections);
      if (this.ruleInfo.can_order_time_array && this.ruleInfo.can_order_time_array.length) {
        this.forEachSections(sections)
      }
      this.sections = sections

    },
    forEachSections(sections) {
      console.log(sections)
      sections.forEach(item => {
        if (item.children && item.children.length) {
          this.forEachSections(item.children)
        } else {
          if (this.ruleInfo.can_order_time_array.includes(item.label)) {
            item.disabled = false
          } else {
            item.disabled = true
          }
        }
      })
    },
    handleCasCaderChage(val) {
      const zdyysc = this.ruleInfo.zdyysc ? this.ruleInfo.zdyysc : 0
      if (val.length > this.ruleInfo.zdyysc) {
        this.$message.error(`该${this.$store.state.themeTitle}室最多只能选择${zdyysc}个节次,请重新选择`);
        this.ruleForm.section = []
        return
      }
    },
    handleProChange(val) {
      this.ruleForm.project_name = this.$until.getLabelName(this.projects, 'id', 'experiment_name', val);
    },
    async getRules(training_room_id) {
      // this.projects = []
      let params = {
        training_room_id,
      }
      let res = await this.$api.instance.interfaceServer('api/order_room/getRuleByTrainingRoomId', 'get', params);
      if (res.code == 0 && res.data) {
        this.ruleInfo = res.data
      } else {
        this.ruleInfo = {}
      }
      this.setSectionsIsDisabled()
    },
    async getProjects(structure_1, structure_2) {
      this.projects = []
      let params = {
        // status: 2,
        structure_1, 
        structure_2,
        page: 1,
        size: 9999
      }
      let res = await this.$api.instance.interfaceServer('api/course-projects/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.projects = res.data.data;
      }
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      if (this.userInfo.defaultStructure) {
        this.selectName = this.userInfo.defaultStructure.structure_text2
      }
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleEditInit(row) {
      this.ruleForm.section = row.section ? row.section.split(",") : []
      if (row.training_room_id) {
        // this.getProjects(row.training_room_id)
        this.getRules(row.training_room_id)
      }
      this.handleEditCallBackSetStruc({ dep: 'order_user_dep', row })
    },
    onSubmit() {
      console.log('submit!');
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, dep: "order_user_dep" });
      this.getProjects(this.ruleForm.order_user_dep,this.ruleForm.major)
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleOrganChange(val) {
      if (val) {
        // this.selectName = this.selectNode.structure_names;
        let strArr = val.split('-');
        this.ruleForm.order_user_dep = strArr[0];
        this.ruleForm.major = strArr[1];
      } else {
        this.ruleForm.order_user_dep = '';
        this.ruleForm.major = '';
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/room/order/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.section = params.section.join(',');
      let res = await this.$api.creat.createTrainroomApply(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      params.section = params.section.join(',');
      let res = await this.$api.instance.interfaceServer(`api/room/order/update`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getClassTearchList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
